import styled, { createGlobalStyle, keyframes, css } from "styled-components";

// Keyframes para animação de spin (refresh icon)
export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Keyframes para animações da tela de sync
export const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
`;

export const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

export const float = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
`;

export const ripple = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.4;
  }
  100% {
    transform: scale(2.5);
    opacity: 0;
  }
`;

// Estilos globais para keyframes (usado em inline styles)
export const GlobalStyles = createGlobalStyle`
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.05);
      opacity: 0.8;
    }
  }

  @keyframes float {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-8px);
    }
  }

  /* Font import for sync screen */
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');
`;

/* ============================================
   WHATSAPP SYNC SCREEN - MODERN DESIGN
   ============================================ */

export const SyncContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #075e54 0%, #128c7e 50%, #25d366 100%);
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;

  /* Background pattern overlay */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    pointer-events: none;
  }

  /* Floating circles decoration */
  &::after {
    content: '';
    position: absolute;
    width: 400px;
    height: 400px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
    top: -100px;
    right: -100px;
    pointer-events: none;
  }

  /* Short screens (desktop/laptop monitors with low height) — enable scroll */
  @media (max-height: 750px) {
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  @media (max-width: 768px) {
    padding: 12px;
    align-items: flex-start;
    padding-top: 20px;
  }

  @media (max-width: 400px) {
    padding: 8px;
    padding-top: 12px;
  }
`;

export const SyncCard = styled.div`
  background: rgba(255, 255, 255, 0.98);
  border-radius: 24px;
  box-shadow:
    0 25px 50px -12px rgba(0, 0, 0, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  max-width: 520px;
  width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 1;
  animation: ${fadeInUp} 0.6s ease-out;

  @media (max-width: 768px) {
    max-width: 100%;
    border-radius: 20px;
  }

  @media (max-width: 400px) {
    border-radius: 16px;
  }
`;

export const SyncHeader = styled.div`
  background: linear-gradient(135deg, #075e54 0%, #128c7e 100%);
  padding: 28px 32px;
  position: relative;
  overflow: hidden;

  /* Decorative element */
  &::after {
    content: '';
    position: absolute;
    bottom: -50%;
    right: -20%;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 60%);
    border-radius: 50%;
  }

  @media (max-width: 768px) {
    padding: 18px 16px;
  }

  @media (max-width: 400px) {
    padding: 14px 12px;
  }
`;

export const SyncHeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  z-index: 1;
`;

export const WhatsAppLogo = styled.div`
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${float} 3s ease-in-out infinite;

  svg {
    width: 32px;
    height: 32px;
    color: white;
  }

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
    border-radius: 14px;

    svg {
      width: 28px;
      height: 28px;
    }
  }

  @media (max-width: 400px) {
    width: 40px;
    height: 40px;
    border-radius: 12px;

    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

export const SyncHeaderText = styled.div`
  flex: 1;

  h1 {
    font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 22px;
    font-weight: 700;
    color: white;
    margin: 0 0 4px 0;
    letter-spacing: -0.3px;
  }

  p {
    font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.85);
    margin: 0;
    font-weight: 400;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 18px;
    }
    p {
      font-size: 13px;
    }
  }

  @media (max-width: 400px) {
    h1 {
      font-size: 16px;
    }
    p {
      font-size: 12px;
    }
  }
`;

export const SyncBody = styled.div`
  padding: 32px;

  @media (max-width: 768px) {
    padding: 16px 14px;
  }

  @media (max-width: 400px) {
    padding: 12px 10px;
  }
`;

export const StepsList = styled.ol`
  list-style: none;
  padding: 0;
  margin: 0 0 28px 0;
  counter-reset: step-counter;

  @media (max-width: 768px) {
    margin: 0 0 16px 0;
  }

  @media (max-width: 400px) {
    margin: 0 0 10px 0;
  }
`;

export const StepItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 14px 0;
  border-bottom: 1px solid #f0f2f5;
  counter-increment: step-counter;
  animation: ${fadeInUp} 0.5s ease-out;
  animation-delay: ${props => props.$delay || '0s'};
  animation-fill-mode: both;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    padding: 10px 0;
    gap: 12px;
  }

  @media (max-width: 400px) {
    padding: 8px 0;
    gap: 10px;
  }
`;

export const StepNumber = styled.span`
  width: 32px;
  height: 32px;
  min-width: 32px;
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
  color: white;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);

  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
    min-width: 28px;
    font-size: 13px;
    border-radius: 8px;
  }

  @media (max-width: 400px) {
    width: 24px;
    height: 24px;
    min-width: 24px;
    font-size: 12px;
    border-radius: 7px;
  }
`;

export const StepText = styled.span`
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 15px;
  color: #3b4a54;
  line-height: 1.5;
  padding-top: 4px;

  strong {
    color: #075e54;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 400px) {
    font-size: 13px;
    padding-top: 2px;
  }
`;

export const QRCodeWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;
`;

export const QRCodeContainer = styled.div`
  background: white;
  border: 2px solid #e8ecef;
  border-radius: 20px;
  padding: 20px;
  position: relative;
  transition: all 0.3s ease;

  &:hover {
    border-color: #25d366;
    box-shadow: 0 8px 30px rgba(37, 211, 102, 0.15);
  }

  @media (max-width: 768px) {
    padding: 12px;
    border-radius: 14px;
  }

  @media (max-width: 400px) {
    padding: 8px;
    border-radius: 12px;
  }
`;

export const QRCodeInner = styled.div`
  width: 260px;
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafbfc;
  border-radius: 16px;
  position: relative;
  overflow: hidden;

  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 8px;
    opacity: ${props => props.$expired ? 0.3 : 1};
    transition: opacity 0.3s ease;
  }

  @media (max-width: 768px) {
    width: 220px;
    height: 220px;
    border-radius: 14px;
  }

  @media (max-width: 400px) {
    width: 200px;
    height: 200px;
  }
`;

export const QRCodeTimer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
  padding: 10px 16px;
  background: ${props => props.$critical ? 'rgba(231, 76, 60, 0.1)' : 'rgba(37, 211, 102, 0.1)'};
  border-radius: 12px;
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.$critical ? '#e74c3c' : '#128c7e'};
  transition: all 0.3s ease;

  svg {
    width: 18px;
    height: 18px;
  }

  @media (max-width: 768px) {
    margin-top: 10px;
    padding: 8px 12px;
    font-size: 13px;
  }

  @media (max-width: 400px) {
    margin-top: 8px;
    padding: 6px 10px;
    font-size: 12px;
  }
`;

export const QRCodeExpired = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(4px);
  border-radius: 16px;
  gap: 12px;
  animation: ${fadeInUp} 0.3s ease-out;

  .icon {
    width: 48px;
    height: 48px;
    background: rgba(231, 76, 60, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #e74c3c;

    svg {
      width: 24px;
      height: 24px;
    }
  }

  .text {
    font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #e74c3c;
  }

  .subtext {
    font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 13px;
    color: #667781;
    font-weight: 400;
  }

  @media (max-width: 768px) {
    gap: 8px;

    .icon {
      width: 40px;
      height: 40px;

      svg {
        width: 20px;
        height: 20px;
      }
    }

    .text {
      font-size: 13px;
    }

    .subtext {
      font-size: 12px;
    }
  }
`;

export const GenerateButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 5px 0px;
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
  color: white;
  border: none;
  border-radius: 14px;
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 24px rgba(37, 211, 102, 0.35);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, transparent 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(37, 211, 102, 0.45);

    &::before {
      opacity: 1;
    }
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 6px 20px rgba(37, 211, 102, 0.35);
  }

  &:disabled {
    background: linear-gradient(135deg, #a8d5ba 0%, #7fbf9e 100%);
    cursor: not-allowed;
    box-shadow: none;
  }

  svg {
    width: 22px;
    height: 22px;
  }

  @media (max-width: 768px) {
    padding: 5px 0px;
    font-size: 15px;
    border-radius: 12px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const RegenerateButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 16px auto 0;
  padding: 12px 24px;
  background: ${props => props.$generating ? '#f0f2f5' : 'rgba(37, 211, 102, 0.1)'};
  color: ${props => props.$generating ? '#667781' : '#128c7e'};
  border: 2px solid ${props => props.$generating ? '#e8ecef' : 'rgba(37, 211, 102, 0.3)'};
  border-radius: 12px;
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: ${props => props.$generating ? 'not-allowed' : 'pointer'};
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: rgba(37, 211, 102, 0.15);
    border-color: rgba(37, 211, 102, 0.5);
  }

  svg {
    width: 18px;
    height: 18px;
    ${props => props.$generating && css`
      animation: ${spin} 1s linear infinite;
    `}
  }

  @media (max-width: 768px) {
    margin: 10px auto 0;
    padding: 10px 20px;
    font-size: 13px;
  }

  @media (max-width: 400px) {
    margin: 8px auto 0;
    padding: 8px 16px;
    font-size: 12px;
  }
`;

export const InitialState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px;
  text-align: center;
`;

export const InitialIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, rgba(37, 211, 102, 0.15) 0%, rgba(18, 140, 126, 0.15) 100%);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${float} 3s ease-in-out infinite;

  svg {
    width: 40px;
    height: 40px;
    color: #25d366;
  }

  @media (max-width: 768px) {
    width: 64px;
    height: 64px;
    border-radius: 20px;

    svg {
      width: 32px;
      height: 32px;
    }
  }

  @media (max-width: 400px) {
    width: 52px;
    height: 52px;
    border-radius: 16px;

    svg {
      width: 28px;
      height: 28px;
    }
  }
`;

export const InitialTitle = styled.h3`
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 18px;
  }

  @media (max-width: 400px) {
    font-size: 16px;
  }
`;

export const InitialSubtitle = styled.p`
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
  color: #667781;
  margin: 0;
  line-height: 1.5;
  max-width: 280px;

  @media (max-width: 768px) {
    font-size: 13px;
  }

  @media (max-width: 400px) {
    font-size: 12px;
  }
`;

export const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;
`;

export const LoadingSpinner = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 3px solid rgba(37, 211, 102, 0.2);
  border-top-color: #25d366;
  animation: ${spin} 0.8s linear infinite;
`;

export const LoadingText = styled.div`
  text-align: center;

  h4 {
    font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 6px 0;
  }

  p {
    font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 13px;
    color: #667781;
    margin: 0;
  }
`;

export const Wrapper = styled.div`
  height: 100%;
  width: 340px;
  background: #f0f2f5;

  position: absolute;
  top: 0;
  z-index: 1;

  transition: all 0.1s ease;

  @media (max-width: 1200px) {
    width: 320px;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1001;
  }
`;

export const Header = styled.header`
  background: #008069;
  height: 108px;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  padding: 20px 0px 14px 0px;

  @media (max-width: 768px) {
    height: 100px;
    padding: 16px 0px 12px 0px;
  }
`;

export const Back = styled.div`
  display: flex;
  align-items: center;

  svg {
    width: 54px;
    cursor: pointer;
    padding: 8px;
    color: #fff;
  }

  h3 {
    color: #ffffff;
    font-size: 19px;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    padding: 0 10px;

    svg {
      width: 48px;
    }

    h3 {
      font-size: 17px;
    }
  }
`;

export const UserImage = styled.div`
  padding: 28px;

  img {
    border-radius: 100%;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    padding: 20px;
    text-align: center;

    img {
      width: 150px;
      height: 150px;
      object-fit: cover;
    }
  }

  @media (max-width: 480px) {
    padding: 15px;

    img {
      width: 120px;
      height: 120px;
    }
  }
`;

export const UserData = styled.div`
  background: #fff;
  padding: 14px 30px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  margin-bottom: 10px;

  span {
    font-size: 14px;
    font-weight: 400;
    color: #008069;
  }

  p {
    font-size: 17px;
    margin: 14px 0px 2px 0;
    color: #111b21;
  }

  @media (max-width: 768px) {
    padding: 12px 20px;
    margin-bottom: 8px;

    span {
      font-size: 13px;
    }

    p {
      font-size: 16px;
      margin: 10px 0px 2px 0;
      word-break: break-word;
    }
  }

  @media (max-width: 480px) {
    padding: 10px 15px;
    margin-bottom: 6px;

    span {
      font-size: 12px;
    }

    p {
      font-size: 15px;
      margin: 8px 0px 2px 0;
    }
  }
`;
